import React, { useState, useEffect } from "react";
import Multiselect from "multiselect-react-dropdown";
import { User, UserDetails } from "../types/User";
import EditIcon from "../../static/images/Editicon.svg";
import DeleteIcon from "../../static/images/Archive.svg";
import x from '../../static/images/x.png'

interface RoleOption {
  label: string;
  value: string;
  id?: number;
}

interface ManageUserRowProps {
  user: User;
  roleOptions: RoleOption[];
  setUsers: React.Dispatch<React.SetStateAction<UserDetails[]>>;
  onRoleChange: (username: string, roles: string) => void;
  onEdit: (user: User) => void; 
  onDelete: (id: string, status: string) => void;
}

const ManageUserRow: React.FC<ManageUserRowProps> = ({
  user,
  roleOptions,
  onRoleChange,
  onEdit,
  onDelete,
}) => {
  // Initialize selectedRoles from user's existing roles
  const [selectedRoles, setSelectedRoles] = useState<RoleOption[]>(() => {
    if (!user.role) return [];

    const userRoles = user.role.split(", ");
    return roleOptions.filter((option) => userRoles.includes(option.value));
  });

  // Update selected roles when user.role changes (e.g., after API fetch)
  useEffect(() => {
    if (user.role) {
      const userRoles = user.role.split(", ");
      const matchingRoles = roleOptions.filter((option) =>
        userRoles.includes(option.value)
      );

      setSelectedRoles(matchingRoles);
    } else {
      setSelectedRoles([]);
    }
  }, [user.role, roleOptions]);

  // Notify parent when roles change
  useEffect(() => {
    const roles = selectedRoles.map((role) => role.value).join(", ");
    if (roles !== user.role) {
      onRoleChange(user.username, roles);
    }
  }, [selectedRoles, user.username, user.role, onRoleChange]);

  const handleSelect = (selectedList: RoleOption[]) => {
    setSelectedRoles(selectedList);
  };

  const handleRemove = (selectedList: RoleOption[]) => {
    setSelectedRoles(selectedList);
  };

  return (
    <tr>
      <td className="p-3">{user.firstName}</td>
      <td className="p-3">{user.lastName}</td>
      <td className="p-3">{user.email}</td>
      <td className="p-3">
        <Multiselect
          options={roleOptions}
          selectedValues={selectedRoles}
          onSelect={handleSelect}
          onRemove={handleRemove}
          displayValue="label"
          avoidHighlightFirstOption
          className="custom-multiselect"
          placeholder={selectedRoles.length > 0 ? "" : "Select roles"}
          customCloseIcon={<img style={{ width: "1rem", height: "1rem", marginLeft:'1rem' }} src={x} alt="close" />}
          
        />
      </td>
      <td className="p-3">{user.knowledgeHub}</td>
      <td className="p-3">{user.crews}</td>
      <td className="p-3">
        <div className="d-flex">
          {user.status === "active" && (
            <button
              className=""
              onClick={() => onEdit(user)} 
              title="Edit"
            >
              <img src={EditIcon} alt="Edit" className="me-2" />
            </button>
          )}
          <button
            className="ms-2"

            onClick={() => onDelete(String(user.id), user.status ?? 'active')}
            title={user.status === 'active'?"Archive":"Make active"}
          >
            <img src={DeleteIcon} alt="Delete" className="me-2" />
          </button>
        </div>
      </td>
    </tr>
  );
};

export default ManageUserRow;
